import { ServiceBase } from './../../../../core/services/ServiceBase'
import ScreeningProxy from './ScreeningProxy'

const slidingExpireTimeInMinute = 60 * 24 // 1 day

class ScreeningService extends ServiceBase {
  getScreeningIndicators(params) {
    return this.getData(() => ScreeningProxy.getScreeningIndicators(params))
  }

  getVSIC(params) {
    return this.applyMemoryCache(
      'CategoryService.getVsic', // Same key in CategoryService
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => ScreeningProxy.getVSIC(params))
  }

  getICB(params) {
    return this.applyMemoryCache(
      'CategoryService.getIcb', // Same key in CategoryService
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => ScreeningProxy.getICB(params))
  }

  getTotalResult(params) {
    return this.getData(() => ScreeningProxy.getTotalResult(params))
  }

  getYearReports(params) {
    return this.applyMemoryCache(
      'ScreeningService.getYearReports',
      params,
    )(() => ScreeningProxy.getYearReports(params))
  }

  getVietnameseLocation(params) {
    return this.applyMemoryCache(
      'CategoryService.getVietnameseLocation', // Same key in CategoryService
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => ScreeningProxy.getVietnameseLocation(params))
  }

  getListingStatus(params) {
    return this.applyMemoryCache(
      'CategoryService.getListingStatus',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => ScreeningProxy.getListingStatus(params))
  }

  getCompanyStatus(params) {
    return this.getData(() => ScreeningProxy.getCompanyStatus(params))
  }

  getLegalForm(params) {
    return this.getData(() => ScreeningProxy.getLegalForm(params))
  }

  getCompanyType(params) {
    return this.getData(() => ScreeningProxy.getCompanyType(params))
  }

  getSuggestData(path, params) {
    return this.getData(() => ScreeningProxy.getSuggestData(path, params))
  }

  getScreeningPrice(params) {
    return this.getData(() => ScreeningProxy.getScreeningPrice(params))
  }

  exportFile(params) {
    return this.getFileDownload(() => ScreeningProxy.exportFile(params))
  }

  saveCriteria(params) {
    return this.getData(() => ScreeningProxy.saveCriteria(params))
  }

  getSavedCriterias(params) {
    return this.getData(() => ScreeningProxy.getSavedCriterias(params))
  }

  getSavedCriteria(params) {
    return this.getData(() => ScreeningProxy.getSavedCriteria(params))
  }

  deleteSavedCriteria(params) {
    return this.getData(() => ScreeningProxy.deleteSavedCriteria(params))
  }

  getVoucher = (params) => {
    return this.getData(() => ScreeningProxy.getVoucher(params))
  }
}

export default new ScreeningService()
